import {
  type QuizQuestionChoice,
  type QuizQuestionChoiceOption,
} from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { generateRandomSlug } from '@efdigital/ll-addon-data/lib/random-slug';
import { type OptionWithValue } from '@efdigital/ll-admin-v2/utils/quiz-choices';
import { uniqueId } from '@ember/helper';
import Component from '@glimmer/component';
import { Type } from '@warp-drive/core/types/symbols';

import { type QuizQuestionEditorComponentSignature } from '../../types/question-manager.ts';
import { DEFAULT_RESPONSE } from '../../types/quiz-responses.ts';
import { EditOptions } from './shared/edit-options.gts';
import RequiredCheckbox from './shared/required-checkbox.gts';

export class MultipleChoiceQuestionEditorComponent extends Component<QuizQuestionEditorComponentSignature> {
  get questionData(): QuizQuestionChoice {
    return this.args.question.choice!;
  }

  updateOptions = (options: QuizQuestionChoiceOption[]) => {
    this.questionData.choices = options;
  };

  addOption = (option?: OptionWithValue) => {
    this.questionData.choices.push({
      [Type]: DataTypeQuiz.QuizQuestionChoiceOption,
      oid: generateRandomSlug(),
      value: option?.value ?? '',
      score: option?.score ?? 0,
      category: '',
      additionalCategories: [],
      correct: false,
      response: DEFAULT_RESPONSE,
    });
  };

  updateOption = (option: QuizQuestionChoiceOption, event: Event) => {
    option.value = (event.target as HTMLInputElement).value;
  };

  removeOptionAt = (index: number) => {
    this.questionData.choices.splice(index, 1);
  };

  setPresets = (options: OptionWithValue[]) => {
    for (const option of options) {
      this.addOption(option);
    }

    const hasAnyScores = options.some((option) => option.score);
    if (hasAnyScores) {
      this.questionData.scoring = 'individual';
    }
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <RequiredCheckbox @question={{@question}} />

        <EditOptions
          @uniqueId={{uniqueId}}
          @options={{this.questionData.choices}}
          @updateOptions={{this.updateOptions}}
          @updateOption={{this.updateOption}}
          @removeOptionAt={{this.removeOptionAt}}
          @addOption={{this.addOption}}
          @setPresets={{this.setPresets}}
          @hasScore={{true}}
        />
      </div>
    {{/let}}
  </template>
}
